import tippy from 'tippy.js';
import { isNil } from 'lodash';

// This is your plugin object. It can be exported to be used anywhere.
const module = {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install(Vue, options) {
    /*
    const mypopperjs = options && options.popperjs ? options.popperjs : Popper;
    const mytooltipjs = options && options.tooltipjs ? options.tooltipjs : Tooltip;

    Object.defineProperties(Vue.prototype, {
      popper: {
        get() {
          return mypopperjs;
        },
      },
    });

    Object.defineProperties(Vue.prototype, {
      tooltip: {
        get() {
          return mytooltipjs;
        },
      },
    });
    */

    // eslint-disable-next-line no-var
    const handleBindOrUpdate = function (el, binding, vnode, oldVnode) {
      if (isNil(binding.value)) return;

      if (!isNil(el.classList) && !isNil(el.closest)) {
        const privacyBlur = !isNil(el.closest('.dashboard--screenshot-mode')) && el.classList.contains('privacy--blur');
        if (privacyBlur) {
          binding.value.delay = 25000;
          binding.value.title = `<span class="privacy--blur--tooltip">${binding.value.title}</span>`;
        }
      }

      const tooltipOptions = {
        arrow: `
        <svg
           version="1.1"
           class="svg-triangle"
           width="100"
           height="100">
          <path
             d="M 49.999998,0 100,100 H 0 Z"
             id="fill"
             style="stroke-width:1.096" />
          <path
             d="M 0.4841856,99.750122 50.000001,1.2104105 99.515814,99.750122"
             id="border"
             style="fill:none;stroke-opacity:1;stroke-miterlimit:4;stroke-dasharray:none;stroke-linecap:square" />
        </svg>
        `,
        // arrowType: 'sharp',
        animation: 'fade',
        theme: typeof binding.value === 'string' ? 'dark' : binding.value.theme || 'dark',
        placement: typeof binding.value === 'string' ? 'top' : binding.value.placement || 'top',
        // placement: 'bottom-start',
        allowHTML: true,
        appendTo: typeof binding.value.container !== 'undefined' ? binding.value.container : document.querySelector('.tooltip__container'),
        boundary: typeof binding.value.boundariesElement !== 'undefined' ? binding.value.boundariesElement : 'window',
        content: typeof binding.value === 'string' ? binding.value : binding.value.title,
        delay: typeof binding.value.delay !== 'undefined' ? [binding.value.delay, 20] : [0, 20],
        duration: 0,
        // touchHold: typeof binding.value.touchHold !== 'undefined' ? binding.value.touchHold : false,
        touch: typeof binding.value.touch !== 'undefined' ? binding.value.touch : true,
        hideOnClick: true,
        ignoreAttributes: true,
        interactive: true,
        lazy: true,
        popperOptions: {
          modifiers: {
            preventOverflow: {
              enabled: typeof binding.value.preventOverflow === 'boolean' ? binding.value.preventOverflow : false,
              boundariesElement: typeof binding.value.boundariesElement !== 'undefined' ? binding.value.boundariesElement : 'scrollParent',
              padding: 5,
            },
            computeStyle: {
              gpuAcceleration: true,
            },
            hide: { enabled: false },
            priority: ['top', 'left', 'right', 'bottom'],
            arrow: { enabled: true },
          },
          eventsEnabled: false,
          positionFixed: true,
          ...binding.value.popperOptions,
          removeOnDestroy: true,
        },
        updateDuration: 100,
        trigger: typeof binding.value.trigger === 'string' ? binding.value.trigger.replace('hover', 'mouseenter') : 'mouseenter focus',
      };

      if (typeof el.tooltip !== 'undefined' && typeof el.tooltip.destroy === 'function') {
        // eslint-disable-next-line no-empty
        // try { el.tooltip.destroy(true); } catch (ignore) { }
        // el.tooltip = tippy(el, tooltipOptions);
        el.tooltip.setContent(tooltipOptions.content);
      } else if (typeof binding.value.title !== 'undefined') {
        el.tooltip = tippy(el, tooltipOptions);
      }
    };

    Vue.directive('tooltip', {
      // called only once, when the directive is first bound to the element. This is where you can do one-time setup work.
      bind: function (el, binding, vnode, oldVnode) {
        handleBindOrUpdate(el, binding, vnode, oldVnode);
      },
      // called when the bound element has been inserted into its parent node (this only guarantees parent node presence, not necessarily in-document).
      inserted: function (el, binding, vnode, oldVnode) {
        handleBindOrUpdate(el, binding, vnode, oldVnode);
      },
      // called after the containing component’s VNode has updated, but possibly before its children have updated.
      // The directive’s value may or may not have changed, but you can skip unnecessary updates by comparing the binding’s
      // current and old values (see below on hook arguments).
      update: function (el, binding, vnode, oldVnode) {
        handleBindOrUpdate(el, binding, vnode, oldVnode);
      },
      // called after the containing component’s VNode and the VNodes of its children have updated.
      componentUpdated: function (el, binding, vnode, oldVnode) {
        handleBindOrUpdate(el, binding, vnode, oldVnode);
        // debounce(() => { handleBindOrUpdate(el, binding, vnode, oldVnode); }, 500);
      },
      // called only once, when the directive is unbound from the element.
      unbind: function (el, binding, vnode, oldVnode) {
        if (typeof el.tooltip !== 'undefined' && typeof el.tooltip.dispose === 'function') {
          el.tooltip.dispose();
        }
      },
    });

    /*
    // We call Vue.mixin() here to inject functionality into all components.
    Vue.mixin({
      // Anything added to a mixin will be injected into all components.
      // In this case, the mounted() method runs when the component is added to the DOM.
      mounted() {
        console.log('Mounted!');
      }
    });
    */
  },
};

export default module;



// WEBPACK FOOTER //
// ./src/plugins/popper-js/index.js